import React, { useState, useEffect } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Box,
   Text,
   FormControl,
   FormLabel,
   Select,
   Checkbox,
   Button,
   Flex,
   useToast,
   VStack,
   HStack,
   ModalFooter,
   Collapse,
} from '@chakra-ui/react';
import { ChevronRightIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { useDispatch } from 'react-redux';
import { updateUserRights, getUser } from '../../../redux/actions/user';

const initialUserRights = {
   dashboard: { add: false, edit: false, deleteRole: false, print: false, view: false },
   journalvouchers: { add: false, edit: false, deleteRole: false, print: false, view: false },
   reports: { add: false, edit: false, deleteRole: false, print: false, view: false },
   profile: { add: false, edit: false, deleteRole: false, print: false, view: false },
   companyprofile: { add: false, edit: false, deleteRole: false, print: false, view: false },
   cashReceive: { add: false, edit: false, deleteRole: false, print: false, view: false },
   cashPayment: { add: false, edit: false, deleteRole: false, print: false, view: false },
   bankReceive: { add: false, edit: false, deleteRole: false, print: false, view: false },
   bankPayment: { add: false, edit: false, deleteRole: false, print: false, view: false },

   // Masters
   customer: { add: false, edit: false, deleteRole: false, print: false, view: false },
   vendor: { add: false, edit: false, deleteRole: false, print: false, view: false },
   allAccount: { add: false, edit: false, deleteRole: false, print: false, view: false },
   item: { add: false, edit: false, deleteRole: false, print: false, view: false },
   category: { add: false, edit: false, deleteRole: false, print: false, view: false },
   brand: { add: false, edit: false, deleteRole: false, print: false, view: false },
   salerepresentative: { add: false, edit: false, deleteRole: false, print: false, view: false },
   itemGroup: { add: false, edit: false, deleteRole: false, print: false, view: false },
   warehouse: { add: false, edit: false, deleteRole: false, print: false, view: false },
   unit: { add: false, edit: false, deleteRole: false, print: false, view: false },
   screen: { add: false, edit: false, deleteRole: false, print: false, view: false },
   daybook: { add: false, edit: false, deleteRole: false, print: false, view: false },
   billtterm: { add: false, edit: false, deleteRole: false, print: false, view: false },
   bankbranch: { add: false, edit: false, deleteRole: false, print: false, view: false },
   transport: { add: false, edit: false, deleteRole: false, print: false, view: false },
   driver: { add: false, edit: false, deleteRole: false, print: false, view: false },
   vehicle: { add: false, edit: false, deleteRole: false, print: false, view: false },
   color: { add: false, edit: false, deleteRole: false, print: false, view: false },
   style: { add: false, edit: false, deleteRole: false, print: false, view: false },
   size: { add: false, edit: false, deleteRole: false, print: false, view: false },
   hsn: { add: false, edit: false, deleteRole: false, print: false, view: false },
   countries: { add: false, edit: false, deleteRole: false, print: false, view: false },
   states: { add: false, edit: false, deleteRole: false, print: false, view: false },
   city: { add: false, edit: false, deleteRole: false, print: false, view: false },
   area: { add: false, edit: false, deleteRole: false, print: false, view: false },

   // Sale
   saleinvoice: { add: false, edit: false, deleteRole: false, print: false, view: false },
   salereturn: { add: false, edit: false, deleteRole: false, print: false, view: false },
   saleorder: { add: false, edit: false, deleteRole: false, print: false, view: false },
   salechallan: { add: false, edit: false, deleteRole: false, print: false, view: false },

   // Purchase
   purchaseinvoice: { add: false, edit: false, deleteRole: false, print: false, view: false },
   purchasereturn: { add: false, edit: false, deleteRole: false, print: false, view: false },
   purchaseorder: { add: false, edit: false, deleteRole: false, print: false, view: false },
   purchasechallan: { add: false, edit: false, deleteRole: false, print: false, view: false },

   // Inventory
   inventory: { add: false, edit: false, deleteRole: false, print: false, view: false },
   inventoryissue: { add: false, edit: false, deleteRole: false, print: false, view: false },
   inventoryreceive: { add: false, edit: false, deleteRole: false, print: false, view: false },
   inventorystocktransfer: { add: false, edit: false, deleteRole: false, print: false, view: false },
};
const ManageUserRoleForm = ({
   isOpen,
   onClose,
   selectedMember,
   companyList,
   processedData,
   onSaveUserRights,
   selectedSharedCompId,
}) => {
   const toast = useToast();
   const dispatch = useDispatch();
   const userId = localStorage.getItem('userId');
   const [selectedCompany, setSelectedCompany] = useState('');
   const [userRights, setUserRights] = useState(initialUserRights);
   const [userRightsByCompany, setUserRightsByCompany] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const [expandedSections, setExpandedSections] = useState({
      masters: false,
      sale: false,
      purchase: false,
      inventory: false,
      cash: false,
      bank: false,
   });

   // Determine if this is being used for sharing (has onSaveUserRights callback)
   const isSharedMode = !!onSaveUserRights;

   // Initialize when modal opens
   useEffect(() => {
      if (isOpen) {

         // SHARED MODE: Single company selection from SharedCompForm
         if (isSharedMode && processedData) {
            let companyId = '';

            if (selectedSharedCompId) {
               companyId = selectedSharedCompId.toString();
            } else if (processedData.companyId) {
               companyId = processedData.companyId.toString();
            } else if (processedData.userRights?.[0]?.companyId) {
               companyId = processedData.userRights[0].companyId.toString();
            }

            setSelectedCompany(companyId);

            // Load permissions from processedData
            if (processedData.userRights?.[0]) {
               const { companyId: _, ...permissions } = processedData.userRights[0];
               const mergedRights = { ...initialUserRights };

               Object.keys(permissions).forEach((key) => {
                  if (mergedRights.hasOwnProperty(key)) {
                     mergedRights[key] = {
                        add: permissions[key]?.add || false,
                        edit: permissions[key]?.edit || false,
                        deleteRole: permissions[key]?.deleteRole || false,
                        print: permissions[key]?.print || false,
                        view: permissions[key]?.view || false,
                     };
                  }
               });

               setUserRights(mergedRights);
            }
         }
         // NORMAL MODE: Multi-company management for existing users
         else if (!isSharedMode && selectedMember) {
            // Organize user rights by company
            const rightsByCompany = {};

            if (selectedMember.userRights?.length > 0) {
               selectedMember.userRights.forEach((right) => {
                  if (right.companyId) {
                     rightsByCompany[right.companyId] = right;
                  }
               });
            } else {
               // Initialize with default rights for each company
               companyList
                  ?.filter((c) => !c.isShared)
                  .forEach((company) => {
                     rightsByCompany[company.id] = { ...initialUserRights };
                  });
            }

            setUserRightsByCompany(rightsByCompany);

            // Select initial company
            let initialCompanyId = '';
            if (selectedMember.companyId) {
               initialCompanyId = String(selectedMember.companyId);
            } else if (selectedMember.userRights?.[0]?.companyId) {
               initialCompanyId = String(selectedMember.userRights[0].companyId);
            } else if (companyList?.length > 0) {
               const firstNonShared = companyList.find((c) => !c.isShared);
               initialCompanyId = String(firstNonShared?.id || '');
            }

            setSelectedCompany(initialCompanyId);

            // Load permissions for initial company
            if (initialCompanyId && rightsByCompany[initialCompanyId]) {
               const { companyId: _, ...permissions } = rightsByCompany[initialCompanyId];
               const mergedRights = { ...initialUserRights };

               Object.keys(permissions).forEach((key) => {
                  if (mergedRights.hasOwnProperty(key)) {
                     mergedRights[key] = {
                        add: permissions[key]?.add || false,
                        edit: permissions[key]?.edit || false,
                        deleteRole: permissions[key]?.deleteRole || false,
                        print: permissions[key]?.print || false,
                        view: permissions[key]?.view || false,
                     };
                  }
               });

               setUserRights(mergedRights);
            }
         }
      }
   }, [isOpen, processedData, selectedSharedCompId, selectedMember, companyList, isSharedMode]);

   // Reset form when modal closes
   useEffect(() => {
      if (!isOpen) {
         setSelectedCompany('');
         setUserRights(initialUserRights);
         setUserRightsByCompany({});
         setExpandedSections({
            masters: false,
            sale: false,
            purchase: false,
            inventory: false,
            cash: false,
            bank: false,
         });
      }
   }, [isOpen]);

   // Handle company change (only in normal mode)
   const handleCompanyChange = (companyId) => {
      // Save current company's permissions before switching
      if (selectedCompany && !isSharedMode) {
         setUserRightsByCompany((prev) => ({
            ...prev,
            [selectedCompany]: {
               companyId: Number(selectedCompany),
               ...userRights,
            },
         }));
      }

      setSelectedCompany(companyId);

      // Load permissions for new company
      if (userRightsByCompany[companyId]) {
         const { companyId: _, ...permissions } = userRightsByCompany[companyId];
         const mergedRights = { ...initialUserRights };

         Object.keys(permissions).forEach((key) => {
            if (mergedRights.hasOwnProperty(key)) {
               mergedRights[key] = {
                  add: permissions[key]?.add || false,
                  edit: permissions[key]?.edit || false,
                  deleteRole: permissions[key]?.deleteRole || false,
                  print: permissions[key]?.print || false,
                  view: permissions[key]?.view || false,
               };
            }
         });

         setUserRights(mergedRights);
      } else {
         setUserRights(initialUserRights);
      }
   };

   const toggleSection = (section) => {
      setExpandedSections((prev) => ({
         ...prev,
         [section]: !prev[section],
      }));
   };

   const getPermissionValue = (permissionKey) => {
      return userRights[permissionKey] || { add: false, edit: false, deleteRole: false, print: false, view: false };
   };

   const updatePermission = (permissionKey, field, value) => {
      setUserRights((prev) => ({
         ...prev,
         [permissionKey]: {
            ...prev[permissionKey],
            [field]: value,
         },
      }));
   };

   const selectSectionPermissions = (permissionKey, value) => {
      setUserRights((prev) => ({
         ...prev,
         [permissionKey]: {
            add: value,
            edit: value,
            deleteRole: value,
            print: value,
            view: value,
         },
      }));
   };

   const getSectionAllSelected = (permissionKey) => {
      const permission = getPermissionValue(permissionKey);
      return permission.add && permission.edit && permission.deleteRole && permission.print && permission.view;
   };

   const selectAllPermissions = (value) => {
      const updatedRights = {};
      Object.keys(initialUserRights).forEach((key) => {
         updatedRights[key] = {
            add: value,
            edit: value,
            deleteRole: value,
            print: value,
            view: value,
         };
      });
      setUserRights(updatedRights);
   };

   const getGlobalAllSelected = () => {
      return Object.keys(initialUserRights).every((key) => getSectionAllSelected(key));
   };

   const selectAllMasters = (value) => {
      const masterPermissions = [
         'customer',
         'vendor',
         'allAccount',
         'item',
         'category',
         'brand',
         'salerepresentative',
         'itemGroup',
         'warehouse',
         'unit',
         'screen',
         'daybook',
         'billtterm',
         'bankbranch',
         'transport',
         'driver',
         'vehicle',
         'color',
         'style',
         'size',
         'hsn',
         'countries',
         'states',
         'city',
         'area',
      ];

      const updatedRights = { ...userRights };
      masterPermissions.forEach((key) => {
         updatedRights[key] = { add: value, edit: value, deleteRole: value, print: value, view: value };
      });
      setUserRights(updatedRights);
   };

   const getAllMastersSelected = () => {
      const masterPermissions = [
         'customer',
         'vendor',
         'allAccount',
         'item',
         'category',
         'brand',
         'salerepresentative',
         'itemGroup',
         'warehouse',
         'unit',
         'screen',
         'daybook',
         'billtterm',
         'bankbranch',
         'transport',
         'driver',
         'vehicle',
         'color',
         'style',
         'size',
         'hsn',
         'countries',
         'states',
         'city',
         'area',
      ];
      return masterPermissions.every((key) => getSectionAllSelected(key));
   };

   const selectAllSale = (value) => {
      ['saleinvoice', 'salereturn', 'saleorder', 'salechallan'].forEach((key) => {
         setUserRights((prev) => ({
            ...prev,
            [key]: { add: value, edit: value, deleteRole: value, print: value, view: value },
         }));
      });
   };

   const getAllSaleSelected = () => {
      return ['saleinvoice', 'salereturn', 'saleorder', 'salechallan'].every((key) => getSectionAllSelected(key));
   };

   const selectAllPurchase = (value) => {
      ['purchaseinvoice', 'purchasereturn', 'purchaseorder', 'purchasechallan'].forEach((key) => {
         setUserRights((prev) => ({
            ...prev,
            [key]: { add: value, edit: value, deleteRole: value, print: value, view: value },
         }));
      });
   };

   const getAllPurchaseSelected = () => {
      return ['purchaseinvoice', 'purchasereturn', 'purchaseorder', 'purchasechallan'].every((key) =>
         getSectionAllSelected(key),
      );
   };

   const selectAllInventory = (value) => {
      ['inventory', 'inventoryissue', 'inventoryreceive', 'inventorystocktransfer'].forEach((key) => {
         setUserRights((prev) => ({
            ...prev,
            [key]: { add: value, edit: value, deleteRole: value, print: value, view: value },
         }));
      });
   };

   const getAllInventorySelected = () => {
      return ['inventory', 'inventoryissue', 'inventoryreceive', 'inventorystocktransfer'].every((key) =>
         getSectionAllSelected(key),
      );
   };

   const handleSubmit = async () => {
      if (!selectedCompany) {
         toast({
            title: 'Error',
            description: 'Please select a company first',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }

      setIsLoading(true);

      try {
         // SHARED MODE: Prepare data for sharing company with new user
         if (isSharedMode && onSaveUserRights) {
            const companyPermissions = {
               companyId: Number(selectedCompany),
               ...userRights,
            };

            const payload = {
               email: selectedMember?.email || processedData?.email,
               mobile: selectedMember?.mobile || processedData?.mobile,
               userRights: [companyPermissions],
            };

            await onSaveUserRights(payload);
         }
         // NORMAL MODE: Update existing user's permissions across multiple companies
         else {
            // Save current company's permissions
            const updatedRightsByCompany = {
               ...userRightsByCompany,
               [selectedCompany]: {
                  companyId: Number(selectedCompany),
                  ...userRights,
               },
            };

            // Convert to array, filtering out companies with no permissions set
            const companiesWithPermissions = Object.values(updatedRightsByCompany).filter((company) => {
               return Object.values(company).some((right) => {
                  if (typeof right !== 'object' || right === null) return false;
                  return right.add || right.edit || right.deleteRole || right.print || right.view;
               });
            });

            const payload = {
               userId: selectedMember?.id || Number(userId),
               userRights: companiesWithPermissions,
            };

            console.log('Normal Mode - Payload:', payload);

            await dispatch(updateUserRights(payload));
            await dispatch(getUser());

            toast({
               title: 'Success',
               description: 'Permissions updated successfully',
               status: 'success',
               duration: 3000,
               isClosable: true,
            });
         }

         onClose();
      } catch (error) {
         console.error('Error updating permissions:', error);
         toast({
            title: 'Error',
            description: error?.response?.data?.message || 'Failed to update permissions',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsLoading(false);
      }
   };

   const PermissionRow = ({ title, permissionKey, isNested = false }) => {
      const permission = getPermissionValue(permissionKey);
      const isAllSelected = getSectionAllSelected(permissionKey);

      return (
         <Flex
            align="center"
            py={3}
            px={4}
            borderBottom="1px"
            borderColor="gray.200"
            bg={isNested ? 'gray.50' : 'white'}
            _hover={{ bg: 'gray.100' }}>
            <Flex align="center" flex="1" minW="200px">
               <Checkbox
                  isChecked={isAllSelected}
                  onChange={(e) => selectSectionPermissions(permissionKey, e.target.checked)}
                  colorScheme="blue"
                  mr={3}
               />
               <Text fontSize="sm" ml={isNested ? 4 : 0}>
                  {title}
               </Text>
            </Flex>

            <HStack spacing={8} flex="1" justify="space-around">
               <Checkbox
                  isChecked={permission.add}
                  onChange={(e) => updatePermission(permissionKey, 'add', e.target.checked)}
                  colorScheme="blue"
               />
               <Checkbox
                  isChecked={permission.edit}
                  onChange={(e) => updatePermission(permissionKey, 'edit', e.target.checked)}
                  colorScheme="blue"
               />
               <Checkbox
                  isChecked={permission.deleteRole}
                  onChange={(e) => updatePermission(permissionKey, 'deleteRole', e.target.checked)}
                  colorScheme="blue"
               />
               <Checkbox
                  isChecked={permission.print}
                  onChange={(e) => updatePermission(permissionKey, 'print', e.target.checked)}
                  colorScheme="blue"
               />
               <Checkbox
                  isChecked={permission.view}
                  onChange={(e) => updatePermission(permissionKey, 'view', e.target.checked)}
                  colorScheme="blue"
               />
            </HStack>
         </Flex>
      );
   };

   const CollapsibleSection = ({ title, sectionKey, onSelectAll, isAllSelected, children }) => {
      const isExpanded = expandedSections[sectionKey];

      return (
         <Box borderBottom="1px" borderColor="gray.200">
            <Flex align="center" py={3} px={4} bg="white" _hover={{ bg: 'gray.50' }}>
               <Box cursor="pointer" onClick={() => toggleSection(sectionKey)} mr={2}>
                  {isExpanded ? <ChevronDownIcon boxSize={5} /> : <ChevronRightIcon boxSize={5} />}
               </Box>
               <Flex align="center" flex="1" minW="200px">
                  <Checkbox
                     isChecked={isAllSelected}
                     onChange={(e) => onSelectAll(e.target.checked)}
                     colorScheme="blue"
                     mr={3}
                  />
                  <Text fontSize="sm" fontWeight="medium">
                     {title}
                  </Text>
               </Flex>
               <HStack spacing={8} flex="1" justify="space-around">
                  <Box w="20px" />
                  <Box w="20px" />
                  <Box w="20px" />
                  <Box w="20px" />
                  <Box w="20px" />
               </HStack>
            </Flex>
            <Collapse in={isExpanded}>
               <Box bg="gray.50">{children}</Box>
            </Collapse>
         </Box>
      );
   };

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
         <ModalOverlay />
         <ModalContent maxH="90vh" m={4}>
            <ModalHeader borderBottom="1px" borderColor="gray.200">
               <Text fontSize="xl" fontWeight="semibold">
                  {isSharedMode ? 'Set Permissions for Shared Company' : 'Manage User Permissions'}
               </Text>
            </ModalHeader>
            <ModalCloseButton />

            <ModalBody p={0}>
               {/* Company Selection */}
               <Box p={6} borderBottom="1px" borderColor="gray.200" bg="gray.50">
                  <FormControl>
                     <Flex align="center">
                        <FormLabel mb={0} mr={4} minW="80px" fontWeight="semibold">
                           Company
                        </FormLabel>
                        {isSharedMode ? (
                           <Text fontWeight="medium">
                              {companyList?.find((c) => c.id.toString() === selectedCompany)?.name || 'N/A'}
                           </Text>
                        ) : (
                           <Select
                              placeholder="Select Company"
                              value={selectedCompany}
                              onChange={(e) => handleCompanyChange(e.target.value)}
                              maxW="300px"
                              bg="white">
                              {companyList
                                 ?.filter((company) => !company.isShared)
                                 .map((company) => (
                                    <option key={company.id} value={company.id.toString()}>
                                       {company.name}
                                    </option>
                                 ))}
                           </Select>
                        )}
                     </Flex>
                  </FormControl>
               </Box>

               <Box>
                  {/* Header Row */}
                  <Flex
                     align="center"
                     py={3}
                     px={4}
                     bg="gray.100"
                     borderBottom="1px"
                     borderColor="gray.300"
                     fontWeight="semibold"
                     fontSize="sm"
                     color="gray.700">
                     <Flex align="center" flex="1" minW="200px">
                        <Checkbox
                           isChecked={getGlobalAllSelected()}
                           onChange={(e) => selectAllPermissions(e.target.checked)}
                           colorScheme="blue"
                           mr={3}
                        />
                        <Text>SELECT ALL</Text>
                     </Flex>
                     <HStack spacing={8} flex="1" justify="space-around">
                        <Text>ADD</Text>
                        <Text>EDIT</Text>
                        <Text>DELETE</Text>
                        <Text>PRINT</Text>
                        <Text>VIEW</Text>
                     </HStack>
                  </Flex>

                  {/* Permission Rows */}
                  <VStack spacing={0} align="stretch">
                     <PermissionRow title="Dashboard" permissionKey="dashboard" />

                     <CollapsibleSection
                        title="Masters"
                        sectionKey="masters"
                        isAllSelected={getAllMastersSelected()}
                        onSelectAll={selectAllMasters}>
                        <PermissionRow title="Customer" permissionKey="customer" isNested />
                        <PermissionRow title="Vendor" permissionKey="vendor" isNested />
                        <PermissionRow title="All Account" permissionKey="allAccount" isNested />
                        <PermissionRow title="Item" permissionKey="item" isNested />
                        <PermissionRow title="Category" permissionKey="category" isNested />
                        <PermissionRow title="Brand" permissionKey="brand" isNested />
                        <PermissionRow title="Sale Representative" permissionKey="salerepresentative" isNested />
                        <PermissionRow title="Item Group" permissionKey="itemGroup" isNested />
                        <PermissionRow title="Warehouse" permissionKey="warehouse" isNested />
                        <PermissionRow title="Unit" permissionKey="unit" isNested />
                        <PermissionRow title="Screen" permissionKey="screen" isNested />
                        <PermissionRow title="Daybook" permissionKey="daybook" isNested />
                        <PermissionRow title="Bill Term" permissionKey="billtterm" isNested />
                        <PermissionRow title="Bank Branch" permissionKey="bankbranch" isNested />
                        <PermissionRow title="Transport" permissionKey="transport" isNested />
                        <PermissionRow title="Driver" permissionKey="driver" isNested />
                        <PermissionRow title="Vehicle" permissionKey="vehicle" isNested />
                        <PermissionRow title="Color" permissionKey="color" isNested />
                        <PermissionRow title="Style" permissionKey="style" isNested />
                        <PermissionRow title="Size" permissionKey="size" isNested />
                        <PermissionRow title="HSN" permissionKey="hsn" isNested />
                        <PermissionRow title="Countries" permissionKey="countries" isNested />
                        <PermissionRow title="States" permissionKey="states" isNested />
                        <PermissionRow title="City" permissionKey="city" isNested />
                        <PermissionRow title="Area" permissionKey="area" isNested />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Sale"
                        sectionKey="sale"
                        isAllSelected={getAllSaleSelected()}
                        onSelectAll={selectAllSale}>
                        <PermissionRow title="Sale Invoice" permissionKey="saleinvoice" isNested />
                        <PermissionRow title="Sale Return" permissionKey="salereturn" isNested />
                        <PermissionRow title="Sale Order" permissionKey="saleorder" isNested />
                        <PermissionRow title="Sale Challan" permissionKey="salechallan" isNested />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Purchase"
                        sectionKey="purchase"
                        isAllSelected={getAllPurchaseSelected()}
                        onSelectAll={selectAllPurchase}>
                        <PermissionRow title="Purchase Invoice" permissionKey="purchaseinvoice" isNested />
                        <PermissionRow title="Purchase Return" permissionKey="purchasereturn" isNested />
                        <PermissionRow title="Purchase Order" permissionKey="purchaseorder" isNested />
                        <PermissionRow title="Purchase Challan" permissionKey="purchasechallan" isNested />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Inventory"
                        sectionKey="inventory"
                        isAllSelected={getAllInventorySelected()}
                        onSelectAll={selectAllInventory}>
                        <PermissionRow title="Inventory" permissionKey="inventory" isNested />
                        <PermissionRow title="Inventory Issue" permissionKey="inventoryissue" isNested />
                        <PermissionRow title="Inventory Receive" permissionKey="inventoryreceive" isNested />
                        <PermissionRow
                           title="Inventory Stock Transfer"
                           permissionKey="inventorystocktransfer"
                           isNested
                        />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Cash"
                        sectionKey="cash"
                        isAllSelected={getSectionAllSelected('cashReceive') && getSectionAllSelected('cashPayment')}
                        onSelectAll={(value) => {
                           if (selectedCompany) {
                              selectSectionPermissions('cashReceive', value);
                              selectSectionPermissions('cashPayment', value);
                           }
                        }}>
                        <PermissionRow title="Cash Receive" permissionKey="cashReceive" isNested />
                        <PermissionRow title="Cash Payment" permissionKey="cashPayment" isNested />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Bank"
                        sectionKey="bank"
                        isAllSelected={getSectionAllSelected('bankReceive') && getSectionAllSelected('bankPayment')}
                        onSelectAll={(value) => {
                           if (selectedCompany) {
                              selectSectionPermissions('bankReceive', value);
                              selectSectionPermissions('bankPayment', value);
                           }
                        }}>
                        <PermissionRow title="Bank Receive" permissionKey="bankReceive" isNested />
                        <PermissionRow title="Bank Payment" permissionKey="bankPayment" isNested />
                     </CollapsibleSection>

                     <PermissionRow title="Journal Vouchers" permissionKey="journalvouchers" />
                     <PermissionRow title="Reports" permissionKey="reports" />
                     <PermissionRow title="Profile" permissionKey="profile" />
                     <PermissionRow title="Company Profile" permissionKey="companyprofile" />
                  </VStack>
               </Box>
            </ModalBody>

            <ModalFooter borderTop="1px" borderColor="gray.200">
               <Button variant="outline" mr={3} onClick={onClose}>
                  Cancel
               </Button>
               <Button
                  colorScheme="green"
                  onClick={handleSubmit}
                  isLoading={isLoading}
                  loadingText="Saving..."
                  isDisabled={!selectedCompany}>
                  Save
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default ManageUserRoleForm;
